import React from 'react';
import { Typography } from '@mui/material';

export const NotFound = () => {
  return (
    <>
      {/* Page Not Found! */}
      <Typography variant='h2'>404: page not found!</Typography>
    </>
  );
};
